import dayjs from 'dayjs';

import React, { useCallback, useMemo, useState } from 'react';

import CompositeFilter, { ANALYSIS_FILTERS, getActiveFilters } from 'components/charts/CompositeFilter';
import Button from 'components/field/Button';
import DateFilter from 'components/field/DateFilter';
import useDefaultFiltersSync from 'components/global/ManageWidgets/useDefaultFiltersSync';
import { calcultateCustomWidgetDateFilter } from 'components/global/ManageWidgets/widgetsUtils';

import useLocale from 'hooks/useLocale';

// use this component to wrap sales page widgets on Monitor view
const SalesBodyProvider = ({ defaultFilters, onApplyFilters, children }) => {
	const { Currency } = useLocale();
	const filtersList = [
		{
			...ANALYSIS_FILTERS.currency,
			filterValues: {
				...ANALYSIS_FILTERS.currency.filterValues,
				value: [Currency]
			}
		},
		ANALYSIS_FILTERS.destinationCountry,
		ANALYSIS_FILTERS.destinationCity,
		ANALYSIS_FILTERS.brand,
		ANALYSIS_FILTERS.salesChannel,
		ANALYSIS_FILTERS.paymentMethod
	];
	const [filtersMenuButtonRef, setFilterMenuButtonRef] = useState(null);
	const [extraFilters, setExtraFilters] = useState(filtersList);
	const [filter, setFilter] = useState({
		start: dayjs().subtract(29, 'day').startOf('day').toISOString(),
		end: dayjs().endOf('day').toISOString()
	});

	const body = useMemo(
		() => ({
			from: filter?.start,
			to: filter?.end,
			filter: getActiveFilters(extraFilters)
		}),
		[filter, extraFilters]
	);

	useDefaultFiltersSync({
		defaultFilters,
		filter,
		setFilter,
		extraFilters,
		setExtraFilters,
		getActiveFilters,
		body,
		onApplyFilters
	});

	const handleDefaultValue = useCallback(() => {
		return calcultateCustomWidgetDateFilter(defaultFilters);
	}, [defaultFilters]);

	return (
		<>
			<div className="pb-2">
				<div style={{ display: 'flex', gap: '1rem' }}>
					<DateFilter
						defaultDay={handleDefaultValue()?.defaultDay || 'last30Days'}
						setValue={setFilter}
						defaultFilter={handleDefaultValue()?.defaultFilter || null}
					/>
					<Button
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/filter-icon.json.gz"
						ref={setFilterMenuButtonRef}
						label="filters"
						variant="borderless"
						size="small"
						className="py-0"
					/>
					<CompositeFilter
						filtersMenuButtonRef={filtersMenuButtonRef}
						filtersList={extraFilters}
						setFiltersList={setExtraFilters}
					/>
				</div>
			</div>
			{typeof children === 'function'
				? children({ body })
				: React.isValidElement(children)
					? React.cloneElement(children, { body })
					: null}
		</>
	);
};

export default SalesBodyProvider;
